// eslint-disable-next-line
export default {
    // Auth
    "auth.login": "Вход",
    "auth.email": "Email",
    "auth.password": "Пароль",
    "auth.enterEmail": "Введите ваш email",
    "auth.enterPassword": "Введите пароль",
    "auth.loginButton": "Войти",
    "auth.loggingIn": "Вход...",
    "auth.loginTitle": "Вход в систему",
    "auth.loginDescription": "Введите ваш email и пароль для входа",
    "auth.logout": "Выйти",
    "auth.authError": "Ошибка авторизации",

    // Common
    "common.loading": "Загрузка...",
    "common.save": "Сохранить",
    "common.cancel": "Отмена",
    "common.delete": "Удалить",
    "common.edit": "Редактировать",
    "common.create": "Создать",
    "common.close": "Закрыть",
    "common.confirm": "Подтвердить",
    "common.yes": "Да",
    "common.no": "Нет",
    "common.search": "Поиск",
    "common.filter": "Фильтр",
    "common.settings": "Настройки",
    "common.active": "Активен",
    "common.inactive": "Неактивен",
    "common.blocked": "Заблокирован",
    "common.total": "Всего",
    "common.deleteUser": "Удалить пользователя",
    "common.resetPassword": "Сбросить пароль",
    "common.confirmDelete": "Подтвердить удаление",
    "common.deleteConfirmText": "Вы уверены, что хотите удалить этого пользователя? Это действие нельзя отменить.",

    // Roles
    "role.admin": "Администратор",
    "role.teacher": "Преподаватель",
    "role.student": "Учащийся",

    // Navigation
    "nav.dashboard": "Панель управления",
    "nav.users": "Пользователи",
    "nav.students": "Учащиеся",
    "nav.teachers": "Преподаватели",
    "nav.courses": "Курсы",
    "nav.schedule": "Расписание",
    "nav.grades": "Оценки",
    "nav.last_entry": "Последний вход",
    "nav.visits": "Количество посещений",
    "nav.never": "Никогда",

    // Admin Dashboard
    "admin.title": "Панель администратора",
    "admin.createTeacher": "Создать преподавателя",
    "admin.systemUsers": "Пользователи системы",
    "admin.userManagement": "Управление всеми пользователями системы",
    "admin.stats.admins": "Админы",
    "admin.stats.teachers": "Преподаватели",
    "admin.stats.students": "Учащиеся",
    "admin.block": "Заблокировать",
    "admin.unblock": "Разблокировать",

    // Teacher Dashboard
    "teacher.title": "Панель преподавателя",
    "teacher.inviteStudent": "Пригласить учащегося",
    "teacher.myStudents": "Мои учащиеся",
    "teacher.studentManagement": "Управление учащимися в ваших группах",
    "teacher.noStudents": "У вас пока нет учащихся",
    "teacher.inviteFirst": "Пригласите первого учащегося, нажав кнопку выше",
    "teacher.addedOn": "Добавлен:",

    // Student Dashboard
    "student.title": "Личный кабинет учащегося",
    "student.personalInfo": "Личная информация",
    "student.yourData": "Ваши данные в системе",
    "student.fullName": "Полное имя",
    "student.role": "Роль",
    "student.status": "Статус",
    "student.courses": "Курсы",
    "student.coursesDesc": "Мои курсы и материалы",
    "student.schedule": "Расписание",
    "student.scheduleDesc": "Расписание занятий",
    "student.grades": "Оценки",
    "student.gradesDesc": "Мои оценки и достижения",
    "student.notifications": "Уведомления",
    "student.updates": "Последние обновления и объявления",
    "student.welcome": "Добро пожаловать в систему!",
    "student.welcomeDesc":
        "Вы успешно зарегистрированы в системе управления школой. Здесь вы сможете просматривать свои курсы, расписание и оценки.",
    "student.today": "Сегодня",
    "student.featuresInDev": "Функции в разработке",
    "student.featuresDesc":
        "Дополнительные функции для студентов (курсы, задания, оценки) будут добавлены в следующих версиях системы.",
    "student.info": "Информация",

    // Password Change
    "password.change": "Смена пароля",
    "password.new": "Новый пароль",
    "password.confirm": "Подтвердите пароль",
    "password.required": "Необходимо сменить временный пароль для продолжения работы",
    "password.enter": "Введите новый пароль для вашего аккаунта",
    "password.minLength": "Минимум 6 символов",
    "password.repeat": "Повторите новый пароль",
    "password.saving": "Сохранение...",
    "password.success": "Пароль успешно изменен",
    "password.error": "Ошибка при смене пароля",
    "password.minError": "Пароль должен содержать минимум 6 символов",
    "password.mismatch": "Пароли не совпадают",

    // Create Teacher Modal
    "createTeacher.title": "Создать преподавателя",
    "createTeacher.description":
        "Введите данные нового преподавателя. На указанный email будет отправлено приглашение.",
    "createTeacher.fullName": "Полное имя",
    "createTeacher.fullNamePlaceholder": "Иванов Иван Иванович",
    "createTeacher.emailPlaceholder": "teacher@school.ru",
    "createTeacher.creating": "Создание...",
    "createTeacher.success": "Преподаватель создан успешно",
    "createTeacher.error": "Ошибка создания преподавателя",
    "createTeacher.exists": "Пользователь с таким email уже существует",

    // Invite Student Modal
    "inviteStudent.title": "Пригласить студента",
    "inviteStudent.description": "Введите данные нового студента. На указанный email будет отправлено приглашение.",
    "inviteStudent.fullName": "Полное имя",
    "inviteStudent.fullNamePlaceholder": "Петров Петр Петрович",
    "inviteStudent.emailPlaceholder": "student@school.ru",
    "inviteStudent.sending": "Отправка приглашения...",
    "inviteStudent.success": "Студент приглашен успешно",
    "inviteStudent.error": "Ошибка приглашения студента",

    // System
    "system.title": "Система дистанционного образования",
    "system.error": "Системная ошибка",
    "system.networkError": "Ошибка сети",
    "system.unauthorized": "Неавторизованный доступ",
    "system.forbidden": "Доступ запрещен",
    "system.notFound": "Не найдено",
    // Trainers
    "messages.userDeleted": "Пользователь успешно удален",
    "messages.passwordReset": "Пароль сброшен и отправлен на email",
    "messages.deleteError": "Ошибка при удалении пользователя",
    "messages.resetError": "Ошибка при сбросе пароля",

    "training.start": "Начать тренировку",
    "trainings.title": "Модули тренировок",
    "trainings.memory": "Тренировка памяти",
    "trainings.memory.description": "Упражнения для тренировки памяти студентов",
    "trainings.logic": "Логические задачи",
    "trainings.logic.description": "Логические задачи и головоломки для студентов",
    "trainings.back": "Назад",
    "trainig.notImplemented": "Этот модуль тренировки еще не реализован",
    // Mental arithmetics
    "trainings.mental": "Ментальная арифметика",
    "trainings.mental.description": "Тренировка ментальной арифметики для студентов",
    "mentalArithmetic": "Ментальная арифметика",
    "trainer": "Тренажёр",
    "flashCards": "Флеш карты",
    "additionSubtraction": "Сложение / вычитание",
    "multiplicationDivision": "Умножение / деление",
    "selectTrainerSettings": "Выберите настройки тренажёра",
    "selectCardsSettings": "Выберите настройки флеш карт",
    "selectMultiSettings": "Выберите настройки тренажёра",
    "go": "Марш",
    "theme": "Тема",
    "difficulty": "Сложность",
    "digits": "Разрядность",
    "actionsCount": "Количество действий",
    "inputTime": "Время на ввод ответа",
    "speed": "Скорость",
    "start": "Старт",
    "stop": "Стоп",
    "settings": "Настройки",
    "continue": "Продолжить",
    "simple": "Просто",
    "brother": "Брат",
    "friend": "Друг",
    "friendBrother": "Друг + Брат",
    "transitions": "Переходы",
    "allThemes": "Все темы",
    "multiplication": "Умножение",
    "division": "Деление",
    "squaring": "Возведение в квадрат",
    "performExercise": "Выполняйте упражнение",
    "yourAnswer": "Ваш ответ:",
    "correct": "Правильно",
    "incorrect": "Неверно",
    "answer": "Ответ",
    "sec": "сек",
    "multiplier": "Множитель",
    "divisor": "Делитель",
    "any": "Любой",
    "multiplicationTable": "Таблица умножения",
    "byMultiplicationTable": "По таблице умножения",
    "resetAllSettings": "Сбросить все настройки и перезагрузить страницу?",
    "difficulties": {
        "0-4": "0-4",
        "0-5": "0-5",
        "0-6": "0-6",
        "0-7": "0-7",
        "0-8": "0-8",
        "0-9": "0-9",
        "4": "4",
        "3": "3",
        "2": "2",
        "1": "1",
        "9": "9",
        "8": "8",
        "7": "7",
        "6": "6",
        "5": "5",
        "50Plus": "50 +",
        "50Minus": "50 -",
        "100Plus": "100 +",
        "100Minus": "100 -"
    },
    "multiDifficulties": {
        "multiplicationTable": "Таблица умножения",
        "2x1": "II x I",
        "3x1": "III x I",
        "2x2": "II x II",
        "4x1": "IIII x I",
        "3x2": "III x II",
        "base50": "База 50",
        "base100": "База 100",
        "base200": "База 200",
        "byMultiplicationTable": "По таблице умножения",
        "2div1": "II / I",
        "3div1": "III / I",
        "4div1": "IIII / I",
        "2div2": "II / II",
        "3div2": "III / II",
        "4div2": "IIII / II",
        "4div3": "IIII / III",
        "2-10": "2-10",
        "on5": "на 5",
        "11-19": "11-19",
        "20-30": "20-30",
        "30-70": "30-70",
        "80-120": "80-120"
    },
    "multiThemes": {
        "multiplication": "Умножение",
        "division": "Деление",
        "squaring": "Возведение в квадрат"
    },
    "cardsDifficulties": {
        "0-4": "0-4",
        "0-9": "0-9"
    }
}